import classNames from "@/utils/classNames";
import { ButtonHTMLAttributes } from "react";

export default function PrimaryButton({
    className = "",
    disabled,
    children,
    ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            data-testid="call-to-action-button"
            {...props}
            className={classNames(
                `inline-flex items-center rounded-full border border-transparent bg-brand-red px-8 py-2 font-medium text-white transition duration-150 ease-in-out hover:bg-brand-primaryButtonHover focus:bg-brand-primaryButtonHover active:bg-brand-primaryButtonClick`,
                disabled ? "cursor-not-allowed opacity-25" : "cursor-pointer",
                className,
            )}
            disabled={disabled}
        >
            {children}
        </button>
    );
}
